/**
 * useMultiAgentEditorChecks — inline editor checks for the multi-agent IDE.
 *
 * The dev-agent editor wires its Monaco markers to the ide-service
 * (`/proxy/ide/validate/apex` for lint, `/proxy/ide/analyze/apex` for static
 * analysis). That service belongs to the dev-agent surface and is NOT reachable
 * from the multi-agent IDE (it 404s locally and would couple the panels to the
 * dev-agent session — the opposite of "all panel data comes from the current
 * multi-agent session").
 *
 * The multi-agent IDE's authoritative compile check is the SAVE gate
 * (validate-save → fix-code, see sessionSaveWithValidation / startMultiAgentAutoFix),
 * not on-type linting. So inline lint/analysis are graceful no-ops here rather
 * than broken calls to a dev-agent service, while still honouring the
 * @ncoder/code-editor LintApi contract.
 */
import { useMemo } from "react";
import type { LintApi, LintResult } from "@ncoder/code-editor";

/** Stable empty marker list for the analysis channel (no static-analysis call). */
export const EMPTY_ANALYSIS_MARKERS: LintResult[] = [];

/** No-op lint API — the real compile check happens on save (validate-save). */
export function useMultiAgentApexLint(): LintApi {
  return useMemo<LintApi>(() => ({ lint: async () => [] }), []);
}
